import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { timelineSummaryDataSelector } from '@store/timeline/data/selectors';
import {
  getSummaryDisplayName,
  SUMMARY_SECONDARY_LIST,
} from '@components/session-timeline/utils/constants';
import { DetailSection, DetailWrapper, Toggle } from './styled';
import SecondaryList from './SecondaryList';
import { formatValue } from './index';
// eslint-disable-next-line react/display-name
export default () => {
  const summary = useSelector(timelineSummaryDataSelector);
  const summaryDisplayNames = getSummaryDisplayName();
  const [showMore, setShowMore] = React.useState(false);
  const toggle = React.useCallback(() => {
    setShowMore(!showMore);
  }, [setShowMore, showMore]);

  return (
    <DetailSection>
      <Toggle onClick={toggle}>{showMore ? 'Hide Details' : 'Show Details'}</Toggle>
      {showMore && (
        <DetailWrapper>
          {Object.keys(SUMMARY_SECONDARY_LIST).map((key) => (
            <SecondaryList
              key={key}
              title={key}
              data={SUMMARY_SECONDARY_LIST[key].map((metric) => {
                const [value, unit] = formatValue(get(summary, [metric]), metric);
                return {
                  metric: summaryDisplayNames[metric] || metric,
                  value,
                  unit,
                };
              })}
            />
          ))}
        </DetailWrapper>
      )}
    </DetailSection>
  );
};
